import type { Setting, Texts, Shipment } from "@/type";
import { formatAddressLines, hasShippingAddress } from "@/utils/tracking";

interface CustomerInfoCardProps {
  settings: Setting;
  texts: Texts;
  shipment: Shipment;
}

export default function CustomerInfoCard({
  settings,
  texts,
  shipment,
}: CustomerInfoCardProps) {
  const { style, font_family } = settings;
  const { colors, general_content_text_size, borders } = style;
  const { customer_info, shipping_address } = shipment;
  const showShippingAddress = hasShippingAddress(shipping_address);
  const addressLines = formatAddressLines(shipping_address);

  const titleStyle = {
    color: colors.text_color.information_title_text,
    fontSize: general_content_text_size.information_title_text,
    fontWeight: 650,
    lineHeight: "20px",
    marginBottom: 16,
  };

  const infoStyle = {
    color: colors.text_color.information_text,
    fontSize: general_content_text_size.information_text,
    fontWeight: 450,
    lineHeight: "20px",
  };

  const labelStyle = { ...infoStyle, fontWeight: 550 };

  return (
    <div
      className="overflow-clip"
      style={{
        backgroundColor: colors.general_color.information_card_background,
        borderRadius: borders.information_card_corner_radius,
        fontFamily: font_family.font,
        border: "1px solid #e3e3e3",
        padding: 16,
      }}
    >
      <p style={titleStyle}>{texts.customer}</p>
      <div className="flex flex-col" style={{ gap: 16 }}>
        <div className="flex flex-col" style={{ gap: 4 }}>
          <p style={labelStyle}>Name</p>
          <p style={infoStyle}>{customer_info.name || "—"}</p>
        </div>
        <div className="flex flex-col" style={{ gap: 4 }}>
          <p style={labelStyle}>{texts.contact_information}</p>
          <p style={infoStyle}>{customer_info.contact_information || "—"}</p>
        </div>
        {showShippingAddress && (
          <div className="flex flex-col" style={{ gap: 4 }}>
            <p style={labelStyle}>{texts.shipping_address}</p>
            <div style={infoStyle}>
              {addressLines.map((line, i) => (
                <p key={i} style={{ margin: 0 }}>
                  {line}
                </p>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
